export default __webpack_public_path__ + "static/media/futebol-half-page.28f5b001.png";